// removed by extract-text-webpack-plugin
module.exports = {"container":"container__1paLG","bodyContainer":"bodyContainer__2eb-z","backgroundBodyOverride":"backgroundBodyOverride__pkjdB"};


//////////////////
// WEBPACK FOOTER
// ./components/partial/container/bicContainer/style.css
// module id = WUb8
// module chunks = 380